/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} See_AllInputs */

const th_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทั้งหมด →`)
};

const en_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All →`)
};

const ja_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて →`)
};

const zh_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部 →`)
};

const es_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todo →`)
};

const pt_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver tudo →`)
};

const id_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua →`)
};

const fr_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout voir →`)
};

const tl_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat →`)
};

const vi_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả →`)
};

const ko_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 →`)
};

const de_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle →`)
};

const ru_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все →`)
};

const tr_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tümü →`)
};

const it_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti →`)
};

const pl_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie →`)
};

const uk_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі →`)
};

const hi_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी →`)
};

const ar_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكل ←`)
};

const ms_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua →`)
};

const bn_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব →`)
};

const zh_tw2_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部 →`)
};

const zh_hk2_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部 →`)
};

const ur_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سب ←`)
};

const fa_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`همه ←`)
};

const sw_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yote →`)
};

const nl_see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle →`)
};

/**
* | output |
* | --- |
* | "All →" |
*
* @param {See_AllInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const see_all = /** @type {((inputs?: See_AllInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<See_AllInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_see_all(inputs)
	if (locale === "ja") return ja_see_all(inputs)
	if (locale === "zh") return zh_see_all(inputs)
	if (locale === "es") return es_see_all(inputs)
	if (locale === "pt") return pt_see_all(inputs)
	if (locale === "id") return id_see_all(inputs)
	if (locale === "fr") return fr_see_all(inputs)
	if (locale === "tl") return tl_see_all(inputs)
	if (locale === "vi") return vi_see_all(inputs)
	if (locale === "ko") return ko_see_all(inputs)
	if (locale === "de") return de_see_all(inputs)
	if (locale === "ru") return ru_see_all(inputs)
	if (locale === "tr") return tr_see_all(inputs)
	if (locale === "it") return it_see_all(inputs)
	if (locale === "pl") return pl_see_all(inputs)
	if (locale === "uk") return uk_see_all(inputs)
	if (locale === "hi") return hi_see_all(inputs)
	if (locale === "ar") return ar_see_all(inputs)
	if (locale === "ms") return ms_see_all(inputs)
	if (locale === "bn") return bn_see_all(inputs)
	if (locale === "zh-TW") return zh_tw2_see_all(inputs)
	if (locale === "zh-HK") return zh_hk2_see_all(inputs)
	if (locale === "ur") return ur_see_all(inputs)
	if (locale === "fa") return fa_see_all(inputs)
	if (locale === "sw") return sw_see_all(inputs)
	if (locale === "nl") return nl_see_all(inputs)
	return en_see_all(inputs)
});